<template>
  <tr
    style="cursor: pointer;"
    @click.stop="handleRowClick"
  >
    <td
      style="width: 0px"
      class="pr-0"
    >
      <v-avatar
        size="32px"
        class="mr-2"
        color="grey lighten-2"
      >
        <v-img :src="item.photo_url">
          <template v-slot:placeholder>
            <v-icon x-small>
              fal fa-user
            </v-icon>
          </template>
        </v-img>
      </v-avatar>
    </td>
    <td style="max-width: 150px">
      <div class="d-flex align-center">
        <div class="flex-grow-1">
          {{ item.last_name }}
          {{ item.first_name }}
        </div>

        <div
          v-if="item.latest_stats && item.latest_stats.injured"
          class="d-flex align-center justify-center ml-2"
          style="width: 24px; min-width: 24px;"
        >
          <img
            :src="injuryIcon"
            style="width: 22px; height: 22px"
          >
        </div>

        <div
          v-if="hasSmartAssistantModule"
          class="d-flex align-center justify-center ml-2"
          style="width: 24px; min-width: 24px; cursor: pointer;"
          @click.stop.prevent="navigateToSmartAssistant"
        >
          <v-tooltip
            v-if="item.smart_assistant.length"
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
              >
                <v-badge
                  :content="item.smart_assistant.length"
                  color="primary"
                  inline
                  :value="item.smart_assistant.length"
                />
              </span>
            </template>
            <span>{{ $tc('tooltip.smart_assistant', item.smart_assistant.length, { num: item.smart_assistant.length }) }}</span>
          </v-tooltip>

          <v-tooltip
            v-else
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
              >
                <v-icon
                  color="success"
                  size="22px"
                >
                  fas fa-circle-check
                </v-icon>
              </span>
            </template>
            <span>{{ $t("smart_assistant.no_alerts") }}</span>
          </v-tooltip>
        </div>
      </div>
    </td>
    <td>
      <v-chip
        v-for="position in item.player_positions.slice(0, 3)"
        :key="item.id + position.id"
        small
        label
        class="mx-1"
      >
        {{ position.short_name }}
      </v-chip>
    </td>
    <td
      v-for="header in layoutVariables.slice(3)"
      :key="header.value"
    >
      <div v-if="header.value === 'pain'">
        <pain-label
          :value="item.latest_stats.pain_max_DL"
          :player-stats="item.latest_stats"
          :gender="item.gender"
        />
      </div>
      <div v-else-if="header.value === 'FMENSACT'">
        <menstrual-phases
          v-if="item.latest_stats.cycle_phase && item.latest_stats.cycle_phase !== noPhase"
          :current-menstrual-phase="item.latest_stats.cycle_phase"
          :stats="item.latest_stats"
        />
        <span
          v-else
          class="grey--text caption"
        >
          N/A
        </span>
      </div>
      <table-bar-value
        v-else-if="header.value !== 'WC'"
        :value="item.latest_stats ? item.latest_stats[header.value] : null"
        :max="players.maxValues && players.maxValues[header.value] ? players.maxValues[header.value] : 100"
        :color="getColorForValue(item.latest_stats[header.value], players.maxValues[header.value] || 100)"
      >
        {{ item.latest_stats ? item.latest_stats[header.value] : '-' }}
      </table-bar-value>

      <div
        v-else-if="header.value === 'WC'"
        class="d-flex align-center"
      >
        {{ formatWCValue }}
        <v-icon
          v-if="shouldShowWCIcon"
          small
          class="ml-1"
          :color="item.latest_stats.WC > 0 ? 'green' : 'red'"
        >
          {{ item.latest_stats.WC > 0 ? 'fal fa-arrow-trend-up' : 'fal fa-arrow-trend-down' }}
        </v-icon>
      </div>
    </td>
  </tr>
</template>

<script>
import TableBarValue from '@/components/helpers/TableBarValue.vue'
import { getColorForValue } from '@/utils/helpers'
import PainLabel from '@/components/helpers/PainLabel.vue'
import MenstrualPhases from '@/components/helpers/MenstrualPhases.vue'
import { MenstrualPhase } from '@/data/models'
import { RouteNames } from '@/router/routes'
import injuryIcon from '@/assets/img/player_info/Injury indicator.svg'

export default {
  name: 'PlayerOverviewTableRow',
  components: { MenstrualPhases, PainLabel, TableBarValue },
  props: {
    item: {
      type: Object,
      required: true
    },
    layoutVariables: {
      type: Array,
      required: true
    },
    players: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    injuryIcon
  }),
  computed: {
    formatWCValue() {
      if (!this.item.latest_stats || this.item.latest_stats.WC === undefined) {
        return '-'
      }
      const wcValue = this.item.latest_stats.WC
      return wcValue >= 0 ? `+${wcValue}` : `${wcValue}`
    },
    shouldShowWCIcon() {
      return this.item.latest_stats &&
        this.item.latest_stats.WC !== 0 &&
        this.item.latest_stats.WC !== undefined
    },
    user() {
      return this.$store.getters[this.$storeGetters.AUTH_USER]
    },
    hasSmartAssistantModule() {
      return this.user.organisation_settings.has_smart_assistant_module
    }
  },
  created() {
    this.noPhase = MenstrualPhase.NO_PHASE
  },
  methods: {
    getColorForValue,
    handleRowClick() {
      this.$emit('click', this.item)
    },
    navigateToSmartAssistant() {
      this.$router.push({ name: RouteNames.PLAYER_SMART_ASSISTANT, params: { id: this.item.id } })
    }
  }
}
</script>
